import { Box, Center, Circle, Divider, Flex, Image, Spacer, Stack, Switch, Td, Text, Tr, VStack } from '@chakra-ui/react'
import React, { useRef, useState,useEffect } from 'react'
import MiniSideBar from '../../components/mini-sidebar'
import { COLORS } from '../../components/styles/colors';
import SecondaryNav from '../../components/seconday-nav';
import DateRangeIndex from '../../components/date-range';
import PrimaryButton from '../../components/primary-button';
import TabSection from '../../components/tabs';
import DynamicModal from '../../components/dynamic-modal';
import useLoader from "../../components/loader/loaderstates";
import Loader from "../../components/loader/loader";
import moment from 'moment';
import { FetchReportsData, FetchExcelReportsData, FetchReportsListData } from '../../middleware/services/reports';
import PatientTurnUpChart from './barchart';
import MedicineChart from './groupedcolumnchart';
import PatientTimeChart from './stackedcolumnchart';
import AppointmentsChart from './dualaxischart';
import ExcelDownload from './downloadexcel';
import MobileSecondaryNav from '../../components/mobile-secondary-navbar';
import MobileNavbar from '../../components/mobile-navbar';
import { transform } from 'framer-motion';
import { useScreenType } from '../../auth';
import SimpleTable from '../../components/simple-table';



const ReportIndex = () => {
    const openCalendar = useRef(null)
    const downloadReport = useRef(null)
    const [data, setData] = useState(null);
    const [reportdata, setReportData] = useState(null);
    const [doctorid, setDoctorid] = useState();
    const today = moment().format("YYYY-MM-DD HH:mm:ss.SSS");
  const thisweekstartdate = moment()
    .startOf("week")
    .format("YYYY-MM-DD HH:mm:ss.SSS");
  const thismonthstartdate = moment()
    .startOf("month")
    .format("YYYY-MM-DD HH:mm:ss.SSS");
  const thisyearstartdate = moment()
    .startOf("year")
    .format("YYYY-MM-DD HH:mm:ss.SSS");
    const currentDate = moment();
    const lastYearStartDate = moment(currentDate).subtract(1, 'year').startOf('year').format("YYYY-MM-DD HH:mm:ss.SSS");
    const lastYearEndDate = moment(currentDate).subtract(1, 'year').endOf('year').format("YYYY-MM-DD HH:mm:ss.SSS");
    const lastMonthStartDate = moment(currentDate).subtract(1, 'month').startOf('month').format("YYYY-MM-DD HH:mm:ss.SSS");
    const lastMonthEndDate = moment(currentDate).subtract(1, 'month').endOf('month').format("YYYY-MM-DD HH:mm:ss.SSS");
    const [activeTab, setActiveTab] = useState(thisweekstartdate);
    const [activeFilter, setActiveFilter] = useState('Week');
    const [activeReport, setActiveReport] = useState('patientturnup');
    const { isLoading, showLoader, dismissLoader } = useLoader();
    const [downloadExcel, setdownloadExcel] = useState(false);
    const [activeTabexcel, setActiveTabExcel] = useState("week")
    const [showGraphs, setShowGraphs] = useState(false)
    const screenType = useScreenType()
    const [ReportsListData, setReportsListData] = useState("");

    const [ShowPatientTrunUpList, setShowPatientTrunUpList] = useState(true);
    const [ShowPatientMedicine, setShowPatientMedicine] = useState(false);
    const [ShowPatientTimeList, setShowPatientTimeList] = useState(false);
    const [ShowPatientAppointmentList, setShowPatientAppointmentList] = useState(false);
    const [ShowPatientDiagnosisList, setShowPatientDiagnosisList] = useState(false);
    

    useEffect(() => {
        fetchListViewData("patientturnup");
      }, []);
      const fetchListViewData = async (type) => {
        showLoader();
        try {
          const result = await FetchReportsListData({
            doctorid, 
            fromdate: activeFilter == 'Today' ? today: activeFilter == 'Week'? thisweekstartdate: activeFilter == 'Month'? thismonthstartdate: activeFilter == "Year"? thisyearstartdate : thisweekstartdate,
            todate: today,
            type: type,
          }, "Week");
          if (result != null) {
            setReportsListData(result);  
            setShowGraphs(false)        
          } else {

          }
          dismissLoader();
        } catch (error) {
          console.error("Error in reports:", error);
        }
      };
      const fetchData = async () => {
        showLoader();
        try {
          const result = await FetchReportsData({
            doctorid,
            fromdate: thisweekstartdate,
            todate: today,
          }, "Week");
          // }, "Week",activeFilter);
           // console.log(result,"charts result")
          if (result != null) {
            setData(result);  
            setShowGraphs(true)         
          } else {
            //console.log("No data");
          }
          dismissLoader();
        } catch (error) {
          console.error("Error in reports:", error);
        }
      };
      
      const handleTabClick = (index) => {
        switch (index) {
          case 0:
            setActiveTab(today);
            fetchFilterData(today, 'Today');
            setActiveFilter('Today')
            break;
          case 1:
            setActiveTab(thisweekstartdate);
            fetchFilterData(thisweekstartdate, 'Week');
            setActiveFilter('Week')
            break;
          case 2:
            setActiveTab(thismonthstartdate);
            fetchFilterData(thismonthstartdate, 'Month');
            setActiveFilter('Month')
            break;
          case 3:
            setActiveTab(thisyearstartdate);
            fetchFilterData(thisyearstartdate, 'Year');
            setActiveFilter('Year')
            break;
          
          default:
            break;
        }
      };
      const handleReportTabClick = (index) => {
          switch (index) {
            case 0:
              fetchListViewData('patientturnup');
              setShowPatientTrunUpList(true);
              setShowPatientMedicine(false);
              setShowPatientTimeList(false);
              setShowPatientAppointmentList(false);
              setShowPatientDiagnosisList(false);
              setActiveReport("patientturnup");
              break;
            case 1:
              fetchListViewData('medicinesprescribed');
              setShowPatientTrunUpList(false);
              setShowPatientMedicine(true);
              setShowPatientTimeList(false);
              setShowPatientAppointmentList(false);
              setShowPatientDiagnosisList(false);
              setActiveReport("medicinesprescribed");
              break;
            case 2:
              fetchListViewData('patienttime');
              setShowPatientTrunUpList(false);
              setShowPatientMedicine(false);
              setShowPatientTimeList(true);
              setShowPatientAppointmentList(false);
              setShowPatientDiagnosisList(false);
              setActiveReport("patienttime");
              break;
            case 3:
              fetchListViewData('appointments');
              setShowPatientTrunUpList(false);
              setShowPatientMedicine(false);
              setShowPatientTimeList(false);
              setShowPatientAppointmentList(true);
              setShowPatientDiagnosisList(false);
              setActiveReport("appointments");
              break;
             case 4:
              fetchListViewData('diagnosis');
              setShowPatientTrunUpList(false);
              setShowPatientMedicine(false);
              setShowPatientTimeList(false);
              setShowPatientAppointmentList(false);
              setShowPatientDiagnosisList(true);
              setActiveReport("diagnosis");
              break;
            default:
              break;
          }
        };
      const fetchFilterData = async (fromdate, type) => {
        setData("")
        showLoader();
        try {
          const result = await FetchReportsData({
            doctorid,
            fromdate: fromdate,
            todate: today,
            type:activeReport,
          }, type);
          if (result != null) {
            setData(result);
           
          } else {
            console.log("No data");
          }
          dismissLoader();
        } catch (error) {
          console.error("Error in DashboardIndex:", error);
        }
      };
      const handlerangedate = async (selecteddate, date, activeFilter)=>{
        // console.log('selecteddate Pages: ', selecteddate)
        // console.log('date Pages: ', date)
        // console.log('activeFilter Pages: ', activeFilter)
        
        showLoader();
        try {
          const result = await FetchReportsData({
            doctorid,
            fromdate: selecteddate.startDate,
            todate: selecteddate.endDate,
          }, date, activeFilter, selecteddate);
        //   console.log('date PagesResult: ', date)
        // console.log('activeFilter PagesResult: ', activeFilter)
        // console.log('selecteddate PagesResult: ', selecteddate)
          // console.log('rangedDate: ',  result)
          if (result != null) {
            setData(result);
           
          } else {
            console.log("No data");
          }
          dismissLoader();
        } catch (error) {
          console.error("Error in DashboardIndex:", error);
        }
      }
      let exceldata = "";
      let rendercomponent = false;
      const generateExcelReport = async () => {
        setdownloadExcel(false);
        setReportData("");
        const tab = activeTabexcel;
        let input = {
          doctorid,
          fromdate: thisweekstartdate,
          todate: today,
          type: "exceldownload",
        };
      
        switch (tab) {
          case "day":
            input.fromdate = today;
            break;
          case "week":
            input.fromdate = thisweekstartdate;
            break;
          case "month":
            input.fromdate = thismonthstartdate;
            break;
          case "lastmonth":
            input.fromdate = lastMonthStartDate;
            input.todate = lastMonthEndDate;
            break;
          case "thisyear":
            input.fromdate = thisyearstartdate;
            break;
          case "lastyear":
            input.fromdate = lastYearStartDate;
            input.todate = lastYearEndDate;
            break;
          default:
            break;
        }
      
        showLoader();
      
        try {
          const result = await FetchExcelReportsData(input);
          if (result) {
            //exceldata = result.output
            //rendercomponent = true;
            console.log(exceldata)
             setReportData(result.output);
             setdownloadExcel(true);
          } else {
            // Handle no data case
          }
        } catch (error) {
          console.error("Error in reports:", error);
        } finally {
          dismissLoader();
        }
      };
      
      // Debounce function to prevent multiple rapid clicks
      const debounce = (func, wait) => {
        let timeout;
        return (...args) => {
          clearTimeout(timeout);
          timeout = setTimeout(() => func.apply(this, args), wait);
        };
      };

      const handleClick = debounce(() => {
        generateExcelReport();
      }, 500);
      const handleDownloadComplete = () => {
        // Reset the download state after completion
        setdownloadExcel(false);
      };
      const ShowGraphs = () => {
        fetchData();
        
      };
    const TableHeader = [
      { key: "patient", label: "Patient" },
      { key: "Email", label: "Email" },
      { key: "mobile", label: "Mobile No" },
      { key: "doctor name", label: "Doctor Name" },
      { key: "date", label: "Appointment Date" },
      { key: "time", label: "Appointment Time" },
    ];
        const TableHeaderMedicine = [
      { key: "patient", label: "Patient" },
      { key: "Email", label: "Email" },
      { key: "mobile", label: "Mobile No" },
      { key: "doctor name", label: "Doctor Name" },
      { key: "date", label: "Appointment Date" },
      { key: "time", label: "Appointment Time" },
      { key: "name", label: "Medicine Name" },
    ];
            const TableHeaderTime = [
      { key: "patient", label: "Patient" },
      { key: "Email", label: "Email" },
      { key: "mobile", label: "Mobile No" },
      { key: "doctor name", label: "Doctor Name" },
      { key: "date", label: "Appointment Date" },
      { key: "time", label: "Appointment Time" },
      { key: "spent time", label: "Spent Time" },
    ];
     const TableHeaderappointments = [
      { key: "patient", label: "Patient" },
      { key: "Email", label: "Email" },
      { key: "mobile", label: "Mobile No" },
      { key: "doctor name", label: "Doctor Name" },
      { key: "date", label: "Appointment Date" },
      { key: "time", label: "Appointment Time" },
      { key: "completed", label: "Completed" },
      { key: "cancelled", label: "Cancelled" },
    ];
    const TableHeaderdiagnosis = [
      { key: "patient", label: "Patient" },
      { key: "Email", label: "Email" },
      { key: "mobile", label: "Mobile No" },
      { key: "doctor name", label: "Doctor Name" },
      { key: "date", label: "Appointment Date" },
      { key: "time", label: "Appointment Time" },
      { key: "Diagnosis", label: "Diagnosis" },
      { key: "Plan", label: "Plan" },
    ];
  return (
    <>
     {isLoading && <Loader />}

     {screenType == 'web' ? (

     
        <Box w="100%">
            <Flex>
                <Box w="6rem">
                    <MiniSideBar />
                </Box>
                <Box w="100%">
                    <SecondaryNav customHeader="Reports" />
                    <Box w="calc(100vw - 6rem)" overflow="hidden auto" h="calc(100vh - 75px)">
                        <Flex>
                            {/* Main container start */}
                            <Box w="100%" bg="#fafafa" overflowX="auto">
                                <Box w="100%">
                                    {/* filter section start */}
                                    <Box display="flex" pos="sticky" top="0" zIndex='99' p="1.5rem" border="1px solid #E6E7E9" justifyContent="space-between" gap="10px" w="100%" alignItems="center" pr="25px">
                                        <TabSection
                                            defaultIndex={1}
                                            tabs={["Today","This week", "This month", "This year"]}
                                            onClickTab={handleTabClick}
                                        />

                                        <Box display="flex" gap="0.5rem">
                                            <Box
                                                as="button"
                                                p="0.625rem"
                                                bg="white"
                                                w="2.5rem"
                                                h="2.5rem"
                                                border="1px solid #E6E7E9"
                                                borderRadius="0.625rem"
                                                onClick={()=> openCalendar.current?.toggleCalendar()}
                                            >
                                                <Image w="1.125rem" src="/assets/imgs/calendar.png" />                  
                                            </Box>
                                            <DateRangeIndex ref={openCalendar} 
                                             onDateChange={(selectedDateValue) =>
                                                handlerangedate(selectedDateValue, 'date', activeFilter)
                                              }
                                             />
                                            <PrimaryButton
                                                fontSize="0.875rem"
                                                variant="mdBtn"
                                                buttonText="Download report"
                                                btnIcon="/assets/svgs/download-white.svg"
                                                btnStyle={{w: "100%"}}
                                                onClick={()=> downloadReport.current.openModal()}
                                            />
                                        </Box>
                                    </Box>
                                    {/* filter section end */}
                                    {/* Tabs Sections Start */}
                                    <Box display="flex" pos="sticky" top="0" zIndex='99' p="1.5rem" border="1px solid #E6E7E9" justifyContent="space-between" gap="10px" w="100%"  alignItems="center" pr="25px">
                                        <TabSection
                                            defaultIndex={0} 
                                            tabs={["Patients","Medicines", "Patient Time", "Appointments", "Diagnosis"]}
                                            onClickTab={handleReportTabClick}
                                        />
                                         <Box display="flex" gap="0.5rem">
                                            <Box
                                                as="button"
                                                p="0.625rem"
                                                bg="white"
                                                w="2.5rem"
                                                h="2.5rem"
                                                border="1px solid #E6E7E9"
                                                borderRadius="0.625rem"
                                                onClick={ShowGraphs}
                                            >
                                                <Image w="1.125rem" src="/assets/svgs/analytics.svg" />                  
                                            </Box>
                                        </Box>
                                    </Box>
                                    {/* Tab section End */}
                                    {/* Table start*/}
                                    {!showGraphs && ShowPatientTrunUpList && ReportsListData && ReportsListData.resultpatientturnup &&  ReportsListData.resultpatientturnup.length > 0 ? (
                                    <Box my="1rem" w='100%'  mt="0.5rem">
                                      <Box
                                      h="calc(100vh - 90px)"
                                      overflow='hidden auto'
                                      border="1px solid #E6E7E9"
                                      >
                                        <SimpleTable
                                          headers={TableHeader}
                                          className='tableContainer'
                                          isDataPresent={true}
                                          //currentPage={currentPage} onPageChange={handlePageChange}
                                          footerStyle={{pos: "fixed", bottom: "0px",boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px", zIndex: "99", w: "100%"}}
                                          tableStyle={{minH:"calc(100vh - 260px)",maxH:"calc(100vh - 260px)",overflowY: "auto",overflowX: "hidden", tableLayout: "fixed", width: "100%"}}
                                          tableBody={
                                            <>
                                              {ReportsListData &&
                                                ReportsListData.resultpatientturnup.map((step, index) => (
                                                  <Tr w="100%" key={index}>
                                                    <Td w="100x">
                                                      <Box w="100%" display="flex" gap="0.5rem" alignItems="center">
                                                        <Box boxSize="2.75rem">
                                                          <Image 
                                                            boxSize="40px" 
                                                            h="40px" 
                                                            objectFit="cover" 
                                                            src={
                                                              step.patientimage ? 
                                                                (step.patientimage.startsWith('https') ? step.patientimage : step.imagepath + step.patientimage) 
                                                                : '/assets/imgs/no-image.png' 
                                                            } 
                                                            borderRadius="full" 
                                                          />
                                                        </Box>
                                                        <Box w="80%" maxW="8rem" isTruncated>
                                                          <Text
                                                          className="textOverflow"
                                                            fontSize=".875rem"
                                                            fontWeight="600"
                                                            title={step.patientname}
                                                          >
                                                            {step.patientname
                                                              ? step.patientname
                                                              : "-"}
                                                          </Text>
                                                        </Box>
                                                      </Box>
                                                    </Td>


                                                  
                                                    <Td>
                                                      <Text fontSize=".875rem" isTruncated title={step.email} fontWeight="500">
                                                        {/* {step.email ? step.email : '-'} */}
                                                        {step.email ? step.email: '-'}
                                                      </Text>
                                                    </Td>

                                                    <Td>
                                                      <Box
                                                        p=".25rem .5rem"
                                                        borderRadius="full"
                                                      >
                                                        <Text
                                                          fontSize=".75rem"
                                                          fontWeight="600"
                                                          //color="#109E6A"
                                                        >
                                                          {/* {step.mobileno ? ((step?.countrycode ? step?.countrycode +  " " : "" ) + step.mobileno) : ('-')} */}
                                                          {step?.mobileno ? `${step?.countrycode || ''} ${step?.mobileno}` : '-'}
                                                        </Text>
                                                      </Box>
                                                    </Td>
                                                     <Td>
                                                      <Text fontSize=".875rem" fontWeight="500">
                                                        {/* {step.email ? step.email : '-'} */}
                                                        {step.doctorname ? step.doctorname: '-'}
                                                      </Text>
                                                    </Td>
                                                     <Td>
                                                      <Text fontSize=".875rem" fontWeight="500">
                                                        {/* {step.email ? step.email : '-'} */}
                                                        {step.appointmentdate ? step.appointmentdate: '-'}
                                                      </Text>
                                                    </Td>
                                                    <Td>
                                                      <Text fontSize=".875rem" fontWeight="500">
                                                        {/* {step.email ? step.email : '-'} */}
                                                        {step.appointmenttime ? step.appointmenttime: '-'}
                                                      </Text>
                                                    </Td>
                                                  </Tr>
                                                ))}
                                            </>
                                          }
                                          footerVisible={false}
                                    //       footerSection={
                                    //         <>
                                    //           <Tr w='100%'>
                                    //             <Td colSpan={7} w="calc(100vw - 6.5rem)">
                                    //               <Box
                                    //                 w="100%"
                                    //                 display="flex"
                                    //                 justifyContent="space-between"
                                    //                 alignItems="center"
                                    //               >
                                    //                   <Box 
                                    // visibility={(totalItemCount < countTo && !totalExceedsPageCount)  ? "hidden" : "visible"}
                                    // >
                                    //     <Text>Showing  <b>{countFrom}</b> to <b>{countTo}</b>  of {totalItemCount} results</Text>
                                    //     </Box>
                                    //     <Box  
                                    //   gap="2.5rem"
                                    //   display="flex"
                                    //   justifyContent="space-between"
                                    //   alignItems="center" >
                                    //                 <Box as="button" onClick={handlePrevClick} disabled={currentPage === 1} visibility={currentPage === 1 ? 'hidden' : 'visible'} p="0.5rem 0.75rem" border="0.0625rem solid #E6E7E9" borderRadius="0.75rem" fontSize="1rem" fontWeight="500">
                                    //                     Previous
                                    //                   </Box>
                                    //                 <Box>
                                    //                   <Text textAlign="center" fontSize=".875rem" fontWeight="600">
                                    //                   Page {currentPage} of {totalPages}
                                    //                   </Text>
                                    //                 </Box>
                                    //                 {(totalItemCount >= countTo && !totalExceedsPageCount)  && 
                                    //                   <Box as="button" p="0.5rem 0.75rem" mr='2.5rem' border="0.0625rem solid #E6E7E9" borderRadius="0.75rem" onClick={handleNextClick} 
                                    //                   disabled={currentPage === totalPages} 
                                    //                   visibility={currentPage === totalPages ? 'hidden' : 'visible'} 
                                    //                   fontSize="1rem" fontWeight="500">
                                    //                     Next
                                    //                   </Box>
                                    //                 }
                                    //                   </Box>
                                    //               </Box>
                                    //             </Td>
                                    //           </Tr>
                                    //         </>
                                    //       }
                                        />
                                      </Box>
                                    </Box>
                                    ) : ( 
                                      null
                                      // <SimpleTable
                                      //   headers={TableHeader}
                                      //   isDataPresent={false}
                                      // />
                                    )}
                                    {!showGraphs && ShowPatientMedicine && ReportsListData && ReportsListData.resultmedicinesprescribed && ReportsListData.resultmedicinesprescribed.length > 0 ? (
                                    <Box my="1rem" w='100%'  mt="0.5rem">
                                      <Box
                                      h="calc(100vh - 90px)"
                                      overflow='hidden auto'
                                      border="1px solid #E6E7E9"
                                      >
                                        <SimpleTable
                                          headers={TableHeaderMedicine}
                                          className='tableContainer'
                                          isDataPresent={true}
                                          //currentPage={currentPage} onPageChange={handlePageChange}
                                          footerStyle={{pos: "fixed", bottom: "0px",boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px", zIndex: "99", w: "100%"}}
                                          tableStyle={{minH:"calc(100vh - 260px)",maxH:"calc(100vh - 260px)",overflowY: "auto",overflowX: "hidden", tableLayout: "fixed", width: "100%"}}
                                          tableBody={
                                            <>
                                              {ReportsListData &&
                                                ReportsListData.resultmedicinesprescribed.map((step, index) => (
                                                  <Tr w="100%" key={index}>
                                                    <Td w="100x">
                                                      <Box w="100%" display="flex" gap="0.5rem" alignItems="center">
                                                        <Box boxSize="2.75rem">
                                                          <Image 
                                                            boxSize="40px" 
                                                            h="40px" 
                                                            objectFit="cover" 
                                                            src={
                                                              step.patientimage ? 
                                                                (step.patientimage.startsWith('https') ? step.patientimage : step.imagepath + step.patientimage) 
                                                                : '/assets/imgs/no-image.png' 
                                                            } 
                                                            borderRadius="full" 
                                                          />
                                                        </Box>
                                                        <Box w="80%" maxW="8rem" isTruncated>
                                                          <Text
                                                          className="textOverflow"
                                                            fontSize=".875rem"
                                                            fontWeight="600"
                                                            title={step.patientname}
                                                          >
                                                            {step.patientname
                                                              ? step.patientname
                                                              : "-"}
                                                          </Text>
                                                        </Box>
                                                      </Box>
                                                    </Td>


                                                  
                                                    <Td>
                                                      <Text fontSize=".875rem" isTruncated title={step.email} fontWeight="500">
                                                        {/* {step.email ? step.email : '-'} */}
                                                        {step.email ? step.email: '-'}
                                                      </Text>
                                                    </Td>

                                                    <Td>
                                                      <Box
                                                        p=".25rem .5rem"
                                                        borderRadius="full"
                                                      >
                                                        <Text
                                                          fontSize=".75rem"
                                                          fontWeight="600"
                                                          //color="#109E6A"
                                                        >
                                                          {/* {step.mobileno ? ((step?.countrycode ? step?.countrycode +  " " : "" ) + step.mobileno) : ('-')} */}
                                                          {step?.mobileno ? `${step?.countrycode || ''} ${step?.mobileno}` : '-'}
                                                        </Text>
                                                      </Box>
                                                    </Td>
                                                     <Td>
                                                      <Text fontSize=".875rem" fontWeight="500">
                                                        {/* {step.email ? step.email : '-'} */}
                                                        {step.doctorname ? step.doctorname: '-'}
                                                      </Text>
                                                    </Td>
                                                     <Td>
                                                      <Text fontSize=".875rem" fontWeight="500">
                                                        {/* {step.email ? step.email : '-'} */}
                                                        {step.prescribeddate ? step.prescribeddate: '-'}
                                                      </Text>
                                                    </Td>
                                                    <Td>
                                                      <Text fontSize=".875rem" fontWeight="500">
                                                        {/* {step.email ? step.email : '-'} */}
                                                        {step.prescribedtime ? step.prescribedtime: '-'}
                                                      </Text>
                                                    </Td>
                                                     <Td>
                                                     <Text fontSize=".875rem" fontWeight="500">
                                                        {step.medicinedetail && step.medicinedetail.length > 0
                                                          ? step.medicinedetail.map(med => med.medicinename).join(", ")
                                                          : '-'}
                                                      </Text>
                                                    </Td>
                                                  </Tr>
                                                ))}
                                            </>
                                          }
                                          footerVisible={false}
                                    //       footerSection={
                                    //         <>
                                    //           <Tr w='100%'>
                                    //             <Td colSpan={7} w="calc(100vw - 6.5rem)">
                                    //               <Box
                                    //                 w="100%"
                                    //                 display="flex"
                                    //                 justifyContent="space-between"
                                    //                 alignItems="center"
                                    //               >
                                    //                   <Box 
                                    // visibility={(totalItemCount < countTo && !totalExceedsPageCount)  ? "hidden" : "visible"}
                                    // >
                                    //     <Text>Showing  <b>{countFrom}</b> to <b>{countTo}</b>  of {totalItemCount} results</Text>
                                    //     </Box>
                                    //     <Box  
                                    //   gap="2.5rem"
                                    //   display="flex"
                                    //   justifyContent="space-between"
                                    //   alignItems="center" >
                                    //                 <Box as="button" onClick={handlePrevClick} disabled={currentPage === 1} visibility={currentPage === 1 ? 'hidden' : 'visible'} p="0.5rem 0.75rem" border="0.0625rem solid #E6E7E9" borderRadius="0.75rem" fontSize="1rem" fontWeight="500">
                                    //                     Previous
                                    //                   </Box>
                                    //                 <Box>
                                    //                   <Text textAlign="center" fontSize=".875rem" fontWeight="600">
                                    //                   Page {currentPage} of {totalPages}
                                    //                   </Text>
                                    //                 </Box>
                                    //                 {(totalItemCount >= countTo && !totalExceedsPageCount)  && 
                                    //                   <Box as="button" p="0.5rem 0.75rem" mr='2.5rem' border="0.0625rem solid #E6E7E9" borderRadius="0.75rem" onClick={handleNextClick} 
                                    //                   disabled={currentPage === totalPages} 
                                    //                   visibility={currentPage === totalPages ? 'hidden' : 'visible'} 
                                    //                   fontSize="1rem" fontWeight="500">
                                    //                     Next
                                    //                   </Box>
                                    //                 }
                                    //                   </Box>
                                    //               </Box>
                                    //             </Td>
                                    //           </Tr>
                                    //         </>
                                    //       }
                                        />
                                      </Box>
                                    </Box>
                                    ) : ( 
                                      null
                                      // <SimpleTable
                                      //   headers={TableHeaderMedicine}
                                      //   isDataPresent={false}
                                      // />
                                    )}
                                    {!showGraphs && ShowPatientTimeList && ReportsListData && ReportsListData.resultpatienttime && ReportsListData.resultpatienttime.length > 0 ? (
                                    <Box my="1rem" w='100%'  mt="0.5rem">
                                      <Box
                                      h="calc(100vh - 90px)"
                                      overflow='hidden auto'
                                      border="1px solid #E6E7E9"
                                      >
                                        <SimpleTable
                                          headers={TableHeaderTime}
                                          className='tableContainer'
                                          isDataPresent={true}
                                          //currentPage={currentPage} onPageChange={handlePageChange}
                                          footerStyle={{pos: "fixed", bottom: "0px",boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px", zIndex: "99", w: "100%"}}
                                          tableStyle={{minH:"calc(100vh - 260px)",maxH:"calc(100vh - 260px)",overflowY: "auto",overflowX: "hidden", tableLayout: "fixed", width: "100%"}}
                                          tableBody={
                                            <>
                                              {ReportsListData &&
                                                ReportsListData.resultpatienttime.map((step, index) => (
                                                  <Tr w="100%" key={index}>
                                                    <Td w="100x">
                                                      <Box w="100%" display="flex" gap="0.5rem" alignItems="center">
                                                        <Box boxSize="2.75rem">
                                                          <Image 
                                                            boxSize="40px" 
                                                            h="40px" 
                                                            objectFit="cover" 
                                                            src={
                                                              step.patientimage ? 
                                                                (step.patientimage.startsWith('https') ? step.patientimage : step.imagepath + step.patientimage) 
                                                                : '/assets/imgs/no-image.png' 
                                                            } 
                                                            borderRadius="full" 
                                                          />
                                                        </Box>
                                                        <Box w="80%" maxW="8rem" isTruncated>
                                                          <Text
                                                          className="textOverflow"
                                                            fontSize=".875rem"
                                                            fontWeight="600"
                                                            title={step.patientname}
                                                          >
                                                            {step.patientname
                                                              ? step.patientname
                                                              : "-"}
                                                          </Text>
                                                        </Box>
                                                      </Box>
                                                    </Td>


                                                  
                                                    <Td>
                                                      <Text fontSize=".875rem" isTruncated title={step.email} fontWeight="500">
                                                        {/* {step.email ? step.email : '-'} */}
                                                        {step.email ? step.email: '-'}
                                                      </Text>
                                                    </Td>

                                                    <Td>
                                                      <Box
                                                        p=".25rem .5rem"
                                                        borderRadius="full"
                                                      >
                                                        <Text
                                                          fontSize=".75rem"
                                                          fontWeight="600"
                                                          //color="#109E6A"
                                                        >
                                                          {/* {step.mobileno ? ((step?.countrycode ? step?.countrycode +  " " : "" ) + step.mobileno) : ('-')} */}
                                                          {step?.mobileno ? `${step?.countrycode || ''} ${step?.mobileno}` : '-'}
                                                        </Text>
                                                      </Box>
                                                    </Td>
                                                     <Td>
                                                      <Text fontSize=".875rem" fontWeight="500">
                                                        {/* {step.email ? step.email : '-'} */}
                                                        {step.doctorname ? step.doctorname: '-'}
                                                      </Text>
                                                    </Td>
                                                     <Td>
                                                      <Text fontSize=".875rem" fontWeight="500">
                                                        {/* {step.email ? step.email : '-'} */}
                                                        {step.appointmentdate ? step.appointmentdate: '-'}
                                                      </Text>
                                                    </Td>
                                                    <Td>
                                                      <Text fontSize=".875rem" fontWeight="500">
                                                        {/* {step.email ? step.email : '-'} */}
                                                        {step.appointmenttime ? step.appointmenttime: '-'}
                                                      </Text>
                                                    </Td>
                                                     <Td>
                                                      <Text fontSize=".875rem" fontWeight="500">
                                                        {/* {step.email ? step.email : '-'} */}
                                                        {step.spenttime ? `${step.spenttime} minutes` : '- minutes'}
                                                      </Text>
                                                    </Td>
                                                  </Tr>
                                                ))}
                                            </>
                                          }
                                          footerVisible={false}
                                    //       footerSection={
                                    //         <>
                                    //           <Tr w='100%'>
                                    //             <Td colSpan={7} w="calc(100vw - 6.5rem)">
                                    //               <Box
                                    //                 w="100%"
                                    //                 display="flex"
                                    //                 justifyContent="space-between"
                                    //                 alignItems="center"
                                    //               >
                                    //                   <Box 
                                    // visibility={(totalItemCount < countTo && !totalExceedsPageCount)  ? "hidden" : "visible"}
                                    // >
                                    //     <Text>Showing  <b>{countFrom}</b> to <b>{countTo}</b>  of {totalItemCount} results</Text>
                                    //     </Box>
                                    //     <Box  
                                    //   gap="2.5rem"
                                    //   display="flex"
                                    //   justifyContent="space-between"
                                    //   alignItems="center" >
                                    //                 <Box as="button" onClick={handlePrevClick} disabled={currentPage === 1} visibility={currentPage === 1 ? 'hidden' : 'visible'} p="0.5rem 0.75rem" border="0.0625rem solid #E6E7E9" borderRadius="0.75rem" fontSize="1rem" fontWeight="500">
                                    //                     Previous
                                    //                   </Box>
                                    //                 <Box>
                                    //                   <Text textAlign="center" fontSize=".875rem" fontWeight="600">
                                    //                   Page {currentPage} of {totalPages}
                                    //                   </Text>
                                    //                 </Box>
                                    //                 {(totalItemCount >= countTo && !totalExceedsPageCount)  && 
                                    //                   <Box as="button" p="0.5rem 0.75rem" mr='2.5rem' border="0.0625rem solid #E6E7E9" borderRadius="0.75rem" onClick={handleNextClick} 
                                    //                   disabled={currentPage === totalPages} 
                                    //                   visibility={currentPage === totalPages ? 'hidden' : 'visible'} 
                                    //                   fontSize="1rem" fontWeight="500">
                                    //                     Next
                                    //                   </Box>
                                    //                 }
                                    //                   </Box>
                                    //               </Box>
                                    //             </Td>
                                    //           </Tr>
                                    //         </>
                                    //       }
                                        />
                                      </Box>
                                    </Box>
                                    ) : ( 
                                      null
                                      // <SimpleTable
                                      //   headers={TableHeaderTime}
                                      //   isDataPresent={false}
                                      // />
                                    )}
                                    {!showGraphs && ShowPatientAppointmentList && ReportsListData && ReportsListData.resultappointments && ReportsListData.resultappointments.length > 0 ? (
                                    <Box my="1rem" w='100%'  mt="0.5rem">
                                      <Box
                                      h="calc(100vh - 90px)"
                                      overflow='hidden auto'
                                      border="1px solid #E6E7E9"
                                      >
                                        <SimpleTable
                                          headers={TableHeaderappointments}
                                          className='tableContainer'
                                          isDataPresent={true}
                                          //currentPage={currentPage} onPageChange={handlePageChange}
                                          footerStyle={{pos: "fixed", bottom: "0px",boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px", zIndex: "99", w: "100%"}}
                                          tableStyle={{minH:"calc(100vh - 260px)",maxH:"calc(100vh - 260px)",overflowY: "auto",overflowX: "hidden", tableLayout: "fixed", width: "100%"}}
                                          tableBody={
                                            <>
                                              {ReportsListData &&
                                                ReportsListData.resultappointments.map((step, index) => (
                                                  <Tr w="100%" key={index}>
                                                    <Td w="100x">
                                                      <Box w="100%" display="flex" gap="0.5rem" alignItems="center">
                                                        <Box boxSize="2.75rem">
                                                          <Image 
                                                            boxSize="40px" 
                                                            h="40px" 
                                                            objectFit="cover" 
                                                            src={
                                                              step.patientimage ? 
                                                                (step.patientimage.startsWith('https') ? step.patientimage : step.imagepath + step.patientimage) 
                                                                : '/assets/imgs/no-image.png' 
                                                            } 
                                                            borderRadius="full" 
                                                          />
                                                        </Box>
                                                        <Box w="80%" maxW="8rem" isTruncated>
                                                          <Text
                                                          className="textOverflow"
                                                            fontSize=".875rem"
                                                            fontWeight="600"
                                                            title={step.patientname}
                                                          >
                                                            {step.patientname
                                                              ? step.patientname
                                                              : "-"}
                                                          </Text>
                                                        </Box>
                                                      </Box>
                                                    </Td>


                                                  
                                                    <Td>
                                                      <Text fontSize=".875rem" isTruncated title={step.email} fontWeight="500">
                                                        {/* {step.email ? step.email : '-'} */}
                                                        {step.email ? step.email: '-'}
                                                      </Text>
                                                    </Td>

                                                    <Td>
                                                      <Box
                                                        p=".25rem .5rem"
                                                        borderRadius="full"
                                                      >
                                                        <Text
                                                          fontSize=".75rem"
                                                          fontWeight="600"
                                                          //color="#109E6A"
                                                        >
                                                          {/* {step.mobileno ? ((step?.countrycode ? step?.countrycode +  " " : "" ) + step.mobileno) : ('-')} */}
                                                          {step?.mobileno ? `${step?.countrycode || ''} ${step?.mobileno}` : '-'}
                                                        </Text>
                                                      </Box>
                                                    </Td>
                                                     <Td>
                                                      <Text fontSize=".875rem" fontWeight="500">
                                                        {/* {step.email ? step.email : '-'} */}
                                                        {step.doctorname ? step.doctorname: '-'}
                                                      </Text>
                                                    </Td>
                                                     <Td>
                                                      <Text fontSize=".875rem" fontWeight="500">
                                                        {/* {step.email ? step.email : '-'} */}
                                                        {step.appointmentdate ? step.appointmentdate: '-'}
                                                      </Text>
                                                    </Td>
                                                    <Td>
                                                      <Text fontSize=".875rem" fontWeight="500">
                                                        {/* {step.email ? step.email : '-'} */}
                                                        {step.appointmenttime ? step.appointmenttime: '-'}
                                                      </Text>
                                                    </Td>
                                                     <Td>
                                                      <Text fontSize=".875rem" fontWeight="500">
                                                        {/* {step.email ? step.email : '-'} */}
                                                        {step.completed ? step.completed: '-'}
                                                      </Text>
                                                    </Td>
                                                     <Td>
                                                      <Text fontSize=".875rem" fontWeight="500">
                                                        {/* {step.email ? step.email : '-'} */}
                                                        {step.canceled ? step.canceled: '-'}
                                                      </Text>
                                                    </Td>
                                                  </Tr>
                                                ))}
                                            </>
                                          }
                                          footerVisible={false}
                                    //       footerSection={
                                    //         <>
                                    //           <Tr w='100%'>
                                    //             <Td colSpan={7} w="calc(100vw - 6.5rem)">
                                    //               <Box
                                    //                 w="100%"
                                    //                 display="flex"
                                    //                 justifyContent="space-between"
                                    //                 alignItems="center"
                                    //               >
                                    //                   <Box 
                                    // visibility={(totalItemCount < countTo && !totalExceedsPageCount)  ? "hidden" : "visible"}
                                    // >
                                    //     <Text>Showing  <b>{countFrom}</b> to <b>{countTo}</b>  of {totalItemCount} results</Text>
                                    //     </Box>
                                    //     <Box  
                                    //   gap="2.5rem"
                                    //   display="flex"
                                    //   justifyContent="space-between"
                                    //   alignItems="center" >
                                    //                 <Box as="button" onClick={handlePrevClick} disabled={currentPage === 1} visibility={currentPage === 1 ? 'hidden' : 'visible'} p="0.5rem 0.75rem" border="0.0625rem solid #E6E7E9" borderRadius="0.75rem" fontSize="1rem" fontWeight="500">
                                    //                     Previous
                                    //                   </Box>
                                    //                 <Box>
                                    //                   <Text textAlign="center" fontSize=".875rem" fontWeight="600">
                                    //                   Page {currentPage} of {totalPages}
                                    //                   </Text>
                                    //                 </Box>
                                    //                 {(totalItemCount >= countTo && !totalExceedsPageCount)  && 
                                    //                   <Box as="button" p="0.5rem 0.75rem" mr='2.5rem' border="0.0625rem solid #E6E7E9" borderRadius="0.75rem" onClick={handleNextClick} 
                                    //                   disabled={currentPage === totalPages} 
                                    //                   visibility={currentPage === totalPages ? 'hidden' : 'visible'} 
                                    //                   fontSize="1rem" fontWeight="500">
                                    //                     Next
                                    //                   </Box>
                                    //                 }
                                    //                   </Box>
                                    //               </Box>
                                    //             </Td>
                                    //           </Tr>
                                    //         </>
                                    //       }
                                        />
                                      </Box>
                                    </Box>
                                    ) : ( 
                                      null
                                      // <SimpleTable
                                      //   headers={TableHeaderappointments}
                                      //   isDataPresent={false}
                                      // />
                                    )}
                                    {!showGraphs && ShowPatientDiagnosisList && ReportsListData && ReportsListData.resultdiagnosis && ReportsListData.resultdiagnosis.length > 0 ? (
                                    <Box my="1rem" w='100%'  mt="0.5rem">
                                      <Box
                                      h="calc(100vh - 90px)"
                                      overflow='hidden auto'
                                      border="1px solid #E6E7E9"
                                      >
                                        <SimpleTable
                                          headers={TableHeaderdiagnosis}
                                          className='tableContainer'
                                          isDataPresent={true}
                                          //currentPage={currentPage} onPageChange={handlePageChange}
                                          footerStyle={{pos: "fixed", bottom: "0px",boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px", zIndex: "99", w: "100%"}}
                                          tableStyle={{minH:"calc(100vh - 260px)",maxH:"calc(100vh - 260px)",overflowY: "auto",overflowX: "hidden", tableLayout: "fixed", width: "100%"}}
                                          tableBody={
                                            <>
                                              {ReportsListData &&
                                                ReportsListData.resultdiagnosis.map((step, index) => (
                                                  <Tr w="100%" key={index}>
                                                    <Td w="100x">
                                                      <Box w="100%" display="flex" gap="0.5rem" alignItems="center">
                                                        <Box boxSize="2.75rem">
                                                          <Image 
                                                            boxSize="40px" 
                                                            h="40px" 
                                                            objectFit="cover" 
                                                            src={
                                                              step.patientimage ? 
                                                                (step.patientimage.startsWith('https') ? step.patientimage : step.imagepath + step.patientimage) 
                                                                : '/assets/imgs/no-image.png' 
                                                            } 
                                                            borderRadius="full" 
                                                          />
                                                        </Box>
                                                        <Box w="80%" maxW="8rem" isTruncated>
                                                          <Text
                                                          className="textOverflow"
                                                            fontSize=".875rem"
                                                            fontWeight="600"
                                                            title={step.patientname}
                                                          >
                                                            {step.patientname
                                                              ? step.patientname
                                                              : "-"}
                                                          </Text>
                                                        </Box>
                                                      </Box>
                                                    </Td>


                                                  
                                                    <Td>
                                                      <Text fontSize=".875rem" isTruncated title={step.email} fontWeight="500">
                                                        {/* {step.email ? step.email : '-'} */}
                                                        {step.email ? step.email: '-'}
                                                      </Text>
                                                    </Td>

                                                    <Td>
                                                      <Box
                                                        p=".25rem .5rem"
                                                        borderRadius="full"
                                                      >
                                                        <Text
                                                          fontSize=".75rem"
                                                          fontWeight="600"
                                                          //color="#109E6A"
                                                        >
                                                          {/* {step.mobileno ? ((step?.countrycode ? step?.countrycode +  " " : "" ) + step.mobileno) : ('-')} */}
                                                          {step?.mobileno ? `${step?.countrycode || ''} ${step?.mobileno}` : '-'}
                                                        </Text>
                                                      </Box>
                                                    </Td>
                                                     <Td>
                                                      <Text fontSize=".875rem" fontWeight="500">
                                                        {/* {step.email ? step.email : '-'} */}
                                                        {step.doctorname ? step.doctorname: '-'}
                                                      </Text>
                                                    </Td>
                                                     <Td>
                                                      <Text fontSize=".875rem" fontWeight="500">
                                                        {/* {step.email ? step.email : '-'} */}
                                                        {step.appointmentdate ? step.appointmentdate: '-'}
                                                      </Text>
                                                    </Td>
                                                    <Td>
                                                      <Text fontSize=".875rem" fontWeight="500">
                                                        {/* {step.email ? step.email : '-'} */}
                                                        {step.appointmenttime ? step.appointmenttime: '-'}
                                                      </Text>
                                                    </Td>
                                                     <Td>
                                                      <Text fontSize=".875rem" fontWeight="500">
                                                        {/* {step.email ? step.email : '-'} */}
                                                        {step.diagnosis ? step.diagnosis: '-'}
                                                      </Text>
                                                    </Td>
                                                     <Td>
                                                      <Text fontSize=".875rem" fontWeight="500">
                                                        {/* {step.email ? step.email : '-'} */}
                                                        {step.plan ? step.plan: '-'}
                                                      </Text>
                                                    </Td>
                                                  </Tr>
                                                ))}
                                            </>
                                          }
                                          footerVisible={false}
                                    //       footerSection={
                                    //         <>
                                    //           <Tr w='100%'>
                                    //             <Td colSpan={7} w="calc(100vw - 6.5rem)">
                                    //               <Box
                                    //                 w="100%"
                                    //                 display="flex"
                                    //                 justifyContent="space-between"
                                    //                 alignItems="center"
                                    //               >
                                    //                   <Box 
                                    // visibility={(totalItemCount < countTo && !totalExceedsPageCount)  ? "hidden" : "visible"}
                                    // >
                                    //     <Text>Showing  <b>{countFrom}</b> to <b>{countTo}</b>  of {totalItemCount} results</Text>
                                    //     </Box>
                                    //     <Box  
                                    //   gap="2.5rem"
                                    //   display="flex"
                                    //   justifyContent="space-between"
                                    //   alignItems="center" >
                                    //                 <Box as="button" onClick={handlePrevClick} disabled={currentPage === 1} visibility={currentPage === 1 ? 'hidden' : 'visible'} p="0.5rem 0.75rem" border="0.0625rem solid #E6E7E9" borderRadius="0.75rem" fontSize="1rem" fontWeight="500">
                                    //                     Previous
                                    //                   </Box>
                                    //                 <Box>
                                    //                   <Text textAlign="center" fontSize=".875rem" fontWeight="600">
                                    //                   Page {currentPage} of {totalPages}
                                    //                   </Text>
                                    //                 </Box>
                                    //                 {(totalItemCount >= countTo && !totalExceedsPageCount)  && 
                                    //                   <Box as="button" p="0.5rem 0.75rem" mr='2.5rem' border="0.0625rem solid #E6E7E9" borderRadius="0.75rem" onClick={handleNextClick} 
                                    //                   disabled={currentPage === totalPages} 
                                    //                   visibility={currentPage === totalPages ? 'hidden' : 'visible'} 
                                    //                   fontSize="1rem" fontWeight="500">
                                    //                     Next
                                    //                   </Box>
                                    //                 }
                                    //                   </Box>
                                    //               </Box>
                                    //             </Td>
                                    //           </Tr>
                                    //         </>
                                    //       }
                                        />
                                      </Box>
                                    </Box>
                                    ) : ( 
                                      null
                                      // <SimpleTable
                                      //   headers={TableHeaderdiagnosis}
                                      //   isDataPresent={false}
                                      // />
                                    )}
                                    {/* Table End */}
                                    {/* charts section start */}
                                    {showGraphs &&
                                    <Flex w="100%" flexWrap="wrap" gap="2rem" p="1.5rem">
                                    {data && data.resultpatientturnup.length > 0 ? (
                                        <Box w="calc(50% - 2rem)">
                                            <Box p="1rem" bg="white" border="1px solid #E6E7E9" borderRadius="0.625rem">
                                                <Box p="1.25rem 1rem" display="flex" justifyContent="space-between">
                                                    <Text fontSize="1rem" fontWeight="500">Patient turn up</Text>
                                                </Box>
                                                <PatientTurnUpChart 
                                                data={data.resultpatientturnup}
                                                height={"344px"}
                                                />  
                                                
                                            </Box>
                                        </Box>
                                    ) : (
                                        <Box w="calc(50% - 2rem)">
                                        <Box bg="white" border="1px solid #E6E7E9" borderRadius="0.625rem">
                                            <Box p="1.25rem 1rem" display="flex" justifyContent="space-between">
                                                <Text fontSize="1rem" fontWeight="500">Patient turn up</Text>
                                                <Text fontSize="0.875rem" fontWeight="500" color="#6A707D">No data available</Text>
                                            </Box>

                                            <Box>
                                                <Image w="100%" borderRadius="0.625rem" src='/assets/imgs/no-data-chart.png' />
                                            </Box>
                                        </Box>
                                    </Box>
                                    )}
                                    {data && data.resultmedicinesprescribed.length > 0 ? (
                                        <Box w="calc(50% - 2rem)">
                                            <Box p="1rem" bg="white" border="1px solid #E6E7E9" borderRadius="0.625rem">
                                                <Box p="1.25rem 1rem" display="flex" justifyContent="space-between">
                                                    <Text fontSize="1rem" fontWeight="500">Medicines Prescribed</Text>
                                                </Box>
                                             <MedicineChart data={data.resultmedicinesprescribed} height={"344px"}/>
                                            </Box>
                                        </Box>
                                    ) : (
                                        <Box w="calc(50% - 2rem)">
                                        <Box bg="white" border="1px solid #E6E7E9" borderRadius="0.625rem">
                                            <Box p="1.25rem 1rem" display="flex" justifyContent="space-between">
                                                <Text fontSize="1rem" fontWeight="500">Medicines Prescribed</Text>
                                                <Text fontSize="0.875rem" fontWeight="500" color="#6A707D">No data available</Text>
                                            </Box>

                                            <Box>
                                                <Image w="100%" borderRadius="0.625rem" src='/assets/imgs/no-data-chart.png' />
                                            </Box>
                                        </Box>
                                    </Box>
                                    )}
                                    
                                     {data && data.resultpatienttime.length > 0 ? (
                                        <Box w="calc(50% - 2rem)">
                                            <Box p="1rem" bg="white" border="1px solid #E6E7E9" borderRadius="0.625rem">
                                                <Box p="1.25rem 1rem" display="flex" justifyContent="space-between">
                                                    <Text fontSize="1rem" fontWeight="500">Patient time</Text>
                                                </Box>
                                            <PatientTimeChart data={data.resultpatienttime} height={"344px"}/>
                                              
                                            </Box>
                                        </Box>
                                     ):(
                                        <Box w="calc(50% - 2rem)">
                                        <Box bg="white" border="1px solid #E6E7E9" borderRadius="0.625rem">
                                            <Box p="1.25rem 1rem" display="flex" justifyContent="space-between">
                                                <Text fontSize="1rem" fontWeight="500">Patient time</Text>
                                                <Text fontSize="0.875rem" fontWeight="500" color="#6A707D">No data available</Text>
                                            </Box>

                                            <Box>
                                                <Image w="100%" borderRadius="0.625rem" src='/assets/imgs/no-data-chart.png' />
                                            </Box>
                                        </Box>
                                    </Box>
                                     )}
                                      
                                      {data && data.resultappointments.length > 0 ? (
                                        <Box w="calc(50% - 2rem)">
                                            <Box p="1rem" bg="white" border="1px solid #E6E7E9" borderRadius="0.625rem">
                                                <Box p="1.25rem 1rem" display="flex" justifyContent="space-between">
                                                    <Text fontSize="1rem" fontWeight="500">Appointments</Text>
                                                </Box>

                                                <AppointmentsChart data={data.resultappointments} height={"344px"}/>
                                            </Box>
                                        </Box>
                                      ):(
                                        <Box w="calc(50% - 2rem)">
                                            <Box bg="white" border="1px solid #E6E7E9" borderRadius="0.625rem">
                                                <Box p="1.25rem 1rem" display="flex" justifyContent="space-between">
                                                    <Text fontSize="1rem" fontWeight="500">Appointments</Text>
                                                    <Text fontSize="0.875rem" fontWeight="500" color="#6A707D">No data available</Text>
                                                </Box>

                                                <Box>
                                                    <Image w="100%" borderRadius="0.625rem" src='/assets/imgs/no-data-chart.png' />
                                                </Box>
                                            </Box>
                                        </Box>
                                      )}
                                    </Flex>
                                    }
                                    {/* charts section end */}
                                </Box>
                                {/* footer section start */}
                                <Box display="flex" my="2rem" alignItems="center" w="100%" justifyContent="center" gap="10px">
                                    <Text fontSize="0.625rem" fontWeight="400">
                                        A PRODUCT OF
                                    </Text>
                                    <Image src="/assets/svgs/tci-logo.svg" />
                                </Box>
                                {/* footer section end */}
                            </Box>
                            {/* Main container end */}
                        </Flex>

                    </Box>
                {/* Main container start */}
                </Box>
            </Flex>
        </Box>
      ) : (
      
      // Mobile responsive
      <Box w="100%">
        <MobileNavbar />
        <MobileSecondaryNav
          header="Reports"
          handlebackarrow={false}
          bottomArea={<>
            <Box display="flex" gap="0.5rem" flexDir='row-reverse' justifyContent='end'>
              <Box
                  as="button"
                  p="0.625rem"
                  bg="white"
                  w="2.5rem"
                  h="2.5rem"
                  border="1px solid #E6E7E9"
                  borderRadius="0.625rem"
                  onClick={()=> openCalendar.current?.toggleCalendar()}
              >
                  <Image w="1.125rem" src="/assets/imgs/calendar.png" />                  
              </Box>
              <DateRangeIndex ref={openCalendar} 
                onDateChange={(selectedDateValue) =>
                  handlerangedate(selectedDateValue)
                }
                calendarStyle={{right: "-70px", transform: "scale(0.9)", top: "20px"}}
                />
              <PrimaryButton
                  fontSize="0.875rem"
                  variant="mdBtn"
                  buttonText="Download report"
                  btnIcon="/assets/svgs/download-white.svg"
                  onClick={()=> downloadReport.current.openModal()}
              />
            </Box>
          </>}
        />
        <Box w="100%" p='1rem'>
          <TabSection
              defaultIndex={1}
              tabs={["Today","This week", "This month", "This year"]}
              onClickTab={handleTabClick}
              
              tabBtnStyle={{minWidth: "unset", fontSize: '14px', px: "10px", whiteSpace:'nowrap'}}
          />
        </Box>

        {/* Main container start */}
        <Box w="100%" bg="#fafafa" h="calc(100vh - 300px)" overflow="hidden auto">
            <Box w="100%">
                {/* charts section start */}
                <Flex w="100%" flexWrap="wrap" gap="2rem" pb="0" p="1.5rem">
                {data && data.resultpatientturnup.length > 0 ? (
                    <Box w="100%">
                        <Box p="1rem" bg="white" border="1px solid #E6E7E9" borderRadius="0.625rem">
                            <Box p="1.25rem 1rem" display="flex" justifyContent="space-between">
                                <Text fontSize="1rem" fontWeight="500">Patient turn up</Text>
                            </Box>
                            <PatientTurnUpChart 
                            data={data.resultpatientturnup}
                            height={"344px"}
                            />  
                            
                        </Box>
                    </Box>
                ) : (
                    <Box w="100%">
                    <Box bg="white" border="1px solid #E6E7E9" borderRadius="0.625rem">
                        <Box p="1.25rem 1rem" display="flex" justifyContent="space-between">
                            <Text fontSize="1rem" fontWeight="500">Patient turn up</Text>
                            <Text fontSize="0.875rem" fontWeight="500" color="#6A707D">No data available</Text>
                        </Box>

                        <Box>
                            <Image w="100%" borderRadius="0.625rem" src='/assets/imgs/no-data-chart.png' />
                        </Box>
                    </Box>
                </Box>
                )}
                {data && data.resultmedicinesprescribed.length > 0 ? (
                    <Box w="100%">
                        <Box p="1rem" bg="white" border="1px solid #E6E7E9" borderRadius="0.625rem">
                            <Box p="1.25rem 1rem" display="flex" justifyContent="space-between">
                                <Text fontSize="1rem" fontWeight="500">Medicines Prescribed</Text>
                            </Box>
                          <MedicineChart data={data.resultmedicinesprescribed} height={"344px"}/>
                        </Box>
                    </Box>
                ) : (
                    <Box w="100%">
                    <Box bg="white" border="1px solid #E6E7E9" borderRadius="0.625rem">
                        <Box p="1.25rem 1rem" display="flex" justifyContent="space-between">
                            <Text fontSize="1rem" fontWeight="500">Medicines Prescribed</Text>
                            <Text fontSize="0.875rem" fontWeight="500" color="#6A707D">No data available</Text>
                        </Box>

                        <Box>
                            <Image w="100%" borderRadius="0.625rem" src='/assets/imgs/no-data-chart.png' />
                        </Box>
                    </Box>
                </Box>
                )}
                {/* Patient Time Chart */}
                  {data && data.resultpatienttime.length > 0 ? (
                    <Box w="100%">
                        <Box p="1rem" bg="white" border="1px solid #E6E7E9" borderRadius="0.625rem">
                            <Box p="1.25rem 1rem" display="flex" justifyContent="space-between">
                                <Text fontSize="1rem" fontWeight="500">Patient time</Text>
                            </Box>
                        <PatientTimeChart data={data.resultpatienttime} height={"344px"}/>
                          
                        </Box>
                    </Box>
                  ):(
                    <Box w="100%">
                    <Box bg="white" border="1px solid #E6E7E9" borderRadius="0.625rem">
                        <Box p="1.25rem 1rem" display="flex" justifyContent="space-between">
                            <Text fontSize="1rem" fontWeight="500">Patient time</Text>
                            <Text fontSize="0.875rem" fontWeight="500" color="#6A707D">No data available</Text>
                        </Box>

                        <Box>
                            <Image w="100%" borderRadius="0.625rem" src='/assets/imgs/no-data-chart.png' />
                        </Box>
                    </Box>
                </Box>
                  )}
                  {/* Appointments Chart */}
                  {data && data.resultappointments.length > 0 ? (
                    <Box w="100%">
                        <Box p="1rem" bg="white" border="1px solid #E6E7E9" borderRadius="0.625rem">
                            <Box p="1.25rem 1rem" display="flex" justifyContent="space-between">
                                <Text fontSize="1rem" fontWeight="500">Appointments</Text>
                            </Box>

                            <AppointmentsChart data={data.resultappointments} height={"344px"}/>
                        </Box>
                    </Box>
                  ):(
                    <Box w="100%">
                        <Box bg="white" border="1px solid #E6E7E9" borderRadius="0.625rem">
                            <Box p="1.25rem 1rem" display="flex" justifyContent="space-between">
                                <Text fontSize="1rem" fontWeight="500">Appointments</Text>
                                <Text fontSize="0.875rem" fontWeight="500" color="#6A707D">No data available</Text>
                            </Box>

                            <Box>
                                <Image w="100%" borderRadius="0.625rem" src='/assets/imgs/no-data-chart.png' />
                            </Box>
                        </Box>
                    </Box>
                  )}
                </Flex>
                {/* charts section end */}
            </Box>
            {/* footer section start */}
            <Box display="flex" mb="2rem" alignItems="center" w="100%" justifyContent="center" gap="10px">
                <Text fontSize="0.625rem" fontWeight="400">
                    A PRODUCT OF
                </Text>
                <Image src="/assets/svgs/tci-logo.svg" />
            </Box>
            {/* footer section end */}
        </Box>
        {/* Main container end */}
      </Box>
      )}

        <DynamicModal
            ref={downloadReport}
            modalHeader="Download report"
            modalWidth="31rem"
            modalBody={
            <>
            {downloadExcel && <ExcelDownload data={reportdata} onDownloadComplete={handleDownloadComplete}/>}
                {/* filter by days start */}
                <Box display="flex" gap="0.5rem" flexWrap="wrap">
                    <Box as='button' onClick={() => setActiveTabExcel('day')} bg={activeTabexcel == "day" ? "#0B0B0D": "white"} color={activeTabexcel == "day" ? "white" : "#0B0B0D"} p="0.5rem 1rem"  border="1px solid #E6E7E9" borderRadius="full">Today</Box>
                    <Box as='button' onClick={() => setActiveTabExcel('week')} bg={activeTabexcel == "week" ? "#0B0B0D": "white"} color={activeTabexcel == "week" ? "white" : "#0B0B0D"} p="0.5rem 1rem" border="1px solid #E6E7E9"  borderRadius="full">This week</Box>
                    <Box as='button' onClick={() => setActiveTabExcel('month')} bg={activeTabexcel == "month" ? "#0B0B0D": "white"} color={activeTabexcel == "month" ? "white" : "#0B0B0D"} p="0.5rem 1rem"  border="1px solid #E6E7E9" borderRadius="full">This month</Box>
                    <Box as='button' onClick={() => setActiveTabExcel('lastmonth')} bg={activeTabexcel == "lastmonth" ? "#0B0B0D": "white"} color={activeTabexcel == "lastmonth" ? "white" : "#0B0B0D"} p="0.5rem 1rem"  border="1px solid #E6E7E9" borderRadius="full">Last month</Box>
                    <Box as='button' onClick={() => setActiveTabExcel('thisyear')} bg={activeTabexcel == "thisyear" ? "#0B0B0D": "white"} color={activeTabexcel == "thisyear" ? "white" : "#0B0B0D"} p="0.5rem 1rem"  border="1px solid #E6E7E9" borderRadius="full">This year</Box>
                    <Box as='button' onClick={() => setActiveTabExcel('lastyear')} bg={activeTabexcel == "lastyear" ? "#0B0B0D": "white"} color={activeTabexcel == "lastyear" ? "white" : "#0B0B0D"} p="0.5rem 1rem"  border="1px solid #E6E7E9" borderRadius="full">Last year</Box>
                </Box>
                {/* filter by days end */}

                {/* download progress start */}
                {/* uploading section start */}
                {/* <Flex flexDir="column" gap="15px" w="100%">
                    <Flex bg="white" flexDir="column" w="100%" p="16px" border="1px solid #E6E7E9" borderRadius="12px">
                        <Box display="flex" gap="15px" w="100%">
                            <Image src="/assets/svgs/pdf-icon.svg" />
                            <Box w="100%">
                                <Box display="flex" justifyContent="space-between" h="auto" w="100%">
                                    <Text fontSize="14px" fontWeight="500">degree_A0587.pdf</Text>
                                    <Box as="button"><Image w="13px" h="13px" src="/assets/imgs/close.png" /></Box>
                                </Box>
                                <Box display="flex" gap="3px">
                                    <Text fontSize="12px" fontWeight="400" color="#6A707D">60 KB of 120 KB</Text>
                                    <Image w="20px" h="auto" src="/assets/svgs/file-upload-spinner.svg" />
                                    <Text fontSize="12px" fontWeight="400" color="#384052">Generating...</Text>
                                </Box>
                            </Box>
                        </Box>
                        <Box h="6px" mt="15px" w="100%" borderRadius="full" bg="#E6E7E9">
                            <Box bg="#1C4EC5" w="35%" h="100%" borderRadius="full"></Box>
                        </Box>
                    </Flex>
                </Flex> */}
                {/* uploading section end */}

                {/* uploaded section start */}
                {/* <Flex flexDir="column" gap="15px" w="100%">
                    <Flex bg="white" flexDir="column" w="100%" p="16px" border="1px solid #E6E7E9" borderRadius="12px">
                        <Box display="flex" gap="15px" w="100%">
                            <Image src="/assets/svgs/pdf-icon.svg" />
                            <Box w="100%">
                                <Box display="flex" justifyContent="space-between" h="auto" w="100%">
                                    <Text fontSize="14px" fontWeight="500">degree_A0587.pdf</Text>
                                    <Box as="button"><Image w="16px" h="18px" src="/assets/imgs/delete.png" /></Box>
                                </Box>
                                <Box display="flex" gap="5px">
                                    <Text fontSize="12px" fontWeight="400" color="#6A707D">120 KB</Text>
                                    <Image w="16px" h="auto" ml="5px" src="/assets/svgs/uploaded-success-icon-green.svg" />
                                    <Text fontSize="12px" fontWeight="400" color="#384052">Ready to download</Text>
                                </Box>
                            </Box>
                        </Box>
                    </Flex>
                </Flex> */}
                {/* uploaded section end */}
                {/* download progress end */}

                {/* <Box display="flex" gap="0.5rem" mt="1rem">
                    <Image src='/assets/svgs/info-icon.svg' />
                    <Text fontSize="0.75rem" fontWeight="500">We'll notify you when your report is ready, you can close the popup.</Text>
                    
                    <Image src='/assets/svgs/uploaded-failed-icon-red.svg' />
                    <Text fontSize="0.75rem" fontWeight="500" color="#CA3A31">Report generation failed, please try again</Text>
                </Box> */}
            </>
            }
            modalFooterBtn={
            <>
                <PrimaryButton buttonText="Download" onClick={handleClick}/>
            </>
            }
        />
    </>
  )
}

export default ReportIndex